import * as React from "react";
import { Input } from "@/dentlab/src/components/ui/input";
import { cn } from "@/dentlab/src/lib/util";
import {
	InputWrapper,
	INVALID_CONTROL_CLASS,
} from "@/dentlab/src/components/input-wrapper";

export interface CustomTextFieldWithPercentageProps
	extends React.InputHTMLAttributes<HTMLInputElement> {
	validationError?: string | null;
	customHelperText?: string;
	name?: string;
	label?: string;
	required?: boolean;
	classNameInput?: string;
	classNameWrapper?: string;
	fullWidth?: boolean;
	inputHeight?: number;
}

export const CustomTextFieldWithPercentage =
	React.memo<CustomTextFieldWithPercentageProps>(
		({
			validationError,
			customHelperText,
			value,
			onChange,
			label,
			required,
			classNameInput,
			classNameWrapper,
			fullWidth = false,
			inputHeight,
			...rest
		}) => {
			return (
				<InputWrapper
					label={label}
					required={required}
					validationError={validationError}
					customHelperText={customHelperText}
					className={cn(fullWidth && "w-full", classNameWrapper)}
				>
					<div className="relative">
						<span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground">
							%
						</span>
						<Input
							{...rest}
							type="number"
							style={
								inputHeight
									? { height: `${inputHeight}px` }
									: undefined
							}
							className={cn(
								"w-full pl-8",
								validationError && INVALID_CONTROL_CLASS,
								classNameInput
							)}
							data-testid={`custom-text-field-percentage-${rest.name}`}
							value={value}
							onChange={onChange}
						/>
					</div>
				</InputWrapper>
			);
		}
	);
